<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <SectionTitle :title="label('title')"/>
      </v-col>
      <v-col cols="12" class="py-0">
        {{label("description1")}}
        <br/>
        {{label("description2")}}
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <JobServiceTerms/>
      </v-col>
      <v-col cols="12" class="py-0">
        <PrivacyPanel/>
      </v-col>
    </v-row>
    <v-row no-gutters class="mb-3">
      <v-col cols="12">
        <v-checkbox
                v-model="agreeTerms"
                :label="label('agreeTerms')"
                hide-details
                @change="onChangeAgree"
        />
        <v-checkbox
                v-model="agreePrivacy"
                :label="label('agreePrivacy')"
                hide-details
                @change="onChangeAgree"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";
  import SectionTitle from "../atoms/SectionTitle";
  import JobServiceTerms from "../molecules/JobServiceTerms";
  import PrivacyPanel from "@/components/molecules/PrivacyPanel";

  export default {
    components: {
      JobServiceTerms,
      SectionTitle,
      PrivacyPanel
    },
    mixins: [ComponentMixin],
    type: "organism",
    name: "TermForm",
    data() {
      return {
        agreeTerms: false,
        agreePrivacy: false
      }
    },
    methods: {
      onChangeAgree() {
        if ( this.agreeTerms && this.agreePrivacy ){
          this.$emit('input', true);
        } else {
          this.$emit('input', false);
        }
      }
    }
  }
</script>

<style scoped>

</style>
